<p-toast></p-toast>
<p-card styleClass="p-card-shadow">
    <div class="card dashboardTable">
        <p-toolbar styleClass="mb-4">
            <ng-template pTemplate="left">
                <!-- <button pButton icon="pi pi-fw pi-plus" label="Add Bank Details" (click)="openNew()"
                    class="p-button-success"></button> -->
                <!-- <button pButton pRipple  icon="pi pi-trash" class="ml-4 p-button-danger" (click)="deleteSelectedProducts()" [disabled]="!selectedBankAccounts || !selectedBankAccounts.length"></button> -->
            </ng-template>
            <ng-template pTemplate="right">
                <!-- <p-fileUpload accept=".jpeg,.pdf,.jpg" mode="basic" [maxFileSize]="5000000" label="Import" chooseLabel="Import" class="mr-2 inline-block"></p-fileUpload> -->
                <button (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT'| translate}}"
                    icon="pi pi-upload" class="p-button-help"></button>
                <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
            </ng-template>

        </p-toolbar>
        <p-table #miSurvey [value]="atalUserData" dataKey="AppId_ProgID" [rows]="10" [paginator]="true" [globalFilterFields]="[
       'AmountEst',
       'AmountPV',
       'AmountSubsidy',
       'ApprovedSubsidyApps',
       'District',
       'NoOfApprovedCases',
       'NoOfApprovedCasesEstimation',
       'NoOfApprovedCasesPV',
       'NoOfCases',
       'NoOfCasesEst',
       'NoOfCasesPV',
       'NoOfCasesSubsidy',
       'SubsidyPaid',
       'TotalArea',
       'TotalAreaEST',
       'TotalAreaPV',
       'TotalAreaSubsidy',
        ]" responsiveLayout="scroll" [rowHover]="true" dataKey="Scheme_Specific_Id"
            currentPageReportTemplate="{{'SHOWING' | translate}} {first} {{'TO' | translate}} {last} {{'OF' | translate}} {totalRecords} {{'ENTRIES' | translate}}"
            [showCurrentPageReport]="true" (onFilter)="tableDataFunction($event)" (onPage)="onPage($event)" [loading]="loading">
            <ng-template pTemplate="caption">
                <div class="flex align-items-center justify-content-between">
                    <h5 class="m-0">{{'ATAL_BHUJAL_USER_REPORT'| translate}}</h5>
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text"
                            (input)="miSurvey.filterGlobal($any($event.target).value, 'contains')"
                            placeholder="{{'SEARCH'| translate}}" />
                    </span>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th [ngClass]="{'row-accessories': true}"></th>

                    <th [ngClass]="{'row-accessories': true}"></th>

                    <th></th>
                    <th>APPLICATIONS</th>
                    <th></th>

                    <th [ngClass]="{'row-accessories': true}"></th>

                    <th></th>
                    <th>ESTIMATE</th>
                    <th></th>
                    <th></th>

                    <th [ngClass]="{'row-accessories': true}"></th>

                    <th></th>
                    <th>PV</th>
                    <th></th>
                    <th></th>

                    <th [ngClass]="{'row-accessories': true}"></th>

                    <th></th>
                    <th></th>
                    <th>SUBSIDY DISBUSMENT</th>
                    <th></th> 
                    <th></th>  
                </tr>

                <tr>
                    <th pSortableColumn="District">{{'District'| translate}}
                        <p-columnFilter type="text" field="District" display="menu"></p-columnFilter>
                        <p-sortIcon field="District"></p-sortIcon>
                    </th>

                    <th [ngClass]="{'row-accessories': true}"></th>

                    <th pSortableColumn="NoOfCases">{{'NO_OF_CASES'| translate}}
                        <p-columnFilter type="text" field="NoOfCases" display="menu"></p-columnFilter>
                        <p-sortIcon field="NoOfCases"></p-sortIcon>
                    </th>
                    <th pSortableColumn="NoOfApprovedCases">{{'APPROVED'| translate}}
                        <p-columnFilter type="text" field="NoOfApprovedCases" display="menu"></p-columnFilter>
                        <p-sortIcon field="NoOfApprovedCases"></p-sortIcon>
                    </th>
                    <th pSortableColumn="TotalArea">{{'AREA_(ACRE)'| translate}}
                        <p-columnFilter type="text" field="TotalArea" display="menu"></p-columnFilter>
                        <p-sortIcon field="TotalArea"></p-sortIcon>
                    </th>

                    <th [ngClass]="{'row-accessories': true}"></th>

                    <th pSortableColumn="NoOfCasesEst">{{'NO_OF_CASES'| translate}}
                        <p-columnFilter type="text" field="NoOfCasesEst" display="menu"></p-columnFilter>
                        <p-sortIcon field="NoOfCasesEst"></p-sortIcon>
                    </th>
                    <th pSortableColumn="NoOfApprovedCasesEstimation">{{'APPROVED'| translate}}
                        <p-columnFilter type="text" field="NoOfApprovedCasesEstimation" display="menu"></p-columnFilter>
                        <p-sortIcon field="NoOfApprovedCasesEstimation"></p-sortIcon>
                    </th>
                    <th pSortableColumn="TotalAreaEST">{{'AREA_(ACRE)'| translate}}
                        <p-columnFilter type="text" field="TotalAreaEST" display="menu"></p-columnFilter>
                        <p-sortIcon field="TotalAreaEST"></p-sortIcon>
                    </th>
                    <th pSortableColumn="AmountEst">{{'AMOUNT_RS'| translate}}
                        <p-columnFilter type="text" field="AmountEst" display="menu"></p-columnFilter>
                        <p-sortIcon field="AmountEst"></p-sortIcon>
                    </th>

                    <th [ngClass]="{'row-accessories': true}"></th>

                    <th pSortableColumn="NoOfCasesPV">{{'NO_OF_CASES'| translate}}
                        <p-columnFilter type="text" field="NoOfCasesPV" display="menu"></p-columnFilter>
                        <p-sortIcon field="NoOfCasesPV"></p-sortIcon>
                    </th>
                    <th pSortableColumn="NoOfApprovedCasesPV">{{'APPROVED'| translate}}
                        <p-columnFilter type="text" field="NoOfApprovedCasesPV" display="menu"></p-columnFilter>
                        <p-sortIcon field="NoOfApprovedCasesPV"></p-sortIcon>
                    </th>
                    <th pSortableColumn="TotalAreaPV">{{'AREA_(ACRE)'| translate}}
                        <p-columnFilter type="text" field="TotalAreaPV" display="menu"></p-columnFilter>
                        <p-sortIcon field="TotalAreaPV"></p-sortIcon>
                    </th>
                    <th pSortableColumn="AmountPV">{{'AMOUNT_RS'| translate}}
                        <p-columnFilter type="text" field="AmountPV" display="menu"></p-columnFilter>
                        <p-sortIcon field="AmountPV"></p-sortIcon>
                    </th>
                    
                    <th [ngClass]="{'row-accessories': true}"></th>

                    <th pSortableColumn="NoOfCasesSubsidy">{{'NO_OF_CASES'| translate}}
                        <p-columnFilter type="text" field="NoOfCasesSubsidy" display="menu"></p-columnFilter>
                        <p-sortIcon field="NoOfCasesSubsidy"></p-sortIcon>
                    </th>
                    <th pSortableColumn="ApprovedSubsidyApps">{{'APPROVED'| translate}}
                        <p-columnFilter type="text" field="ApprovedSubsidyApps" display="menu"></p-columnFilter>
                        <p-sortIcon field="ApprovedSubsidyApps"></p-sortIcon>
                    </th>
                    <th pSortableColumn="TotalAreaSubsidy">{{'AREA_(ACRE)'| translate}}
                        <p-columnFilter type="text" field="TotalAreaSubsidy" display="menu"></p-columnFilter>
                        <p-sortIcon field="TotalAreaSubsidy"></p-sortIcon>
                    </th>
                    <th pSortableColumn="AmountSubsidy">{{'AMOUNT_RS'| translate}}
                        <p-columnFilter type="text" field="AmountSubsidy" display="menu"></p-columnFilter>
                        <p-sortIcon field="AmountSubsidy"></p-sortIcon>
                    </th>

                    <th pSortableColumn="SubsidyPaid">{{'PAID'| translate}}
                        <p-columnFilter type="text" field="SubsidyPaid" display="menu"></p-columnFilter>
                        <p-sortIcon field="SubsidyPaid"></p-sortIcon>
                    </th> 
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-data>
                <tr>
                    <td>{{data.District}}</td>
                    <td></td>

                    <td>{{data.NoOfCases}}</td>
                    <td>{{data.NoOfApprovedCases}}</td>
                    <td>{{data.TotalArea}}</td>

                    <td></td>
                    
                    <td>{{data.NoOfCasesEst}}</td>
                    <td>{{data.NoOfApprovedCasesEstimation}}</td>
                    <td>{{data.TotalAreaEST}}</td>
                    <td>{{data.AmountEst}}</td>

                    <td></td>
                    
                    
                    <td>{{data.NoOfCasesPV}}</td>
                    <td>{{data.NoOfApprovedCasesPV}}</td>
                    <td>{{data.TotalAreaPV}}</td>
                    <td>{{data.AmountPV}}</td>

                    <td></td>
                    
                    
                    <td>{{data.NoOfCasesSubsidy}}</td>
                    <td>{{data.ApprovedSubsidyApps}}</td>
                    <td>{{data.TotalAreaSubsidy}}</td>
                    <td>{{data.AmountSubsidy}}</td>
                    <td>{{data.SubsidyPaid}}</td>
                    

                </tr>
            </ng-template>
            <!-- <ng-template pTemplate="footer">
                <tr>
                    <td> Total</td>
                    <td>{{totalChallanDeposited | number:'1.0-2'}}</td>
                    <td>{{totalAmountDeposited | number:'1.0-2'}}</td>
                    <td>{{totalChallanRejected | number:'1.0-2'}}</td>
                    <td>{{totalAmountRejected | number:'1.0-2'}}</td>
                </tr>
                <tr>
                    <td> Grand Total</td>
                    <td>{{grandTotalChallanDeposited | number:'1.0-2'}}</td>
                    <td>{{grandTotalAmountDeposited | number:'1.0-2'}}</td>
                    <td>{{grandTotalChallanRejected | number:'1.0-2'}}</td>
                    <td>{{grandTotalAmountRejected | number:'1.0-2'}}</td>
                </tr>
            </ng-template> -->

        </p-table>
    </div>
</p-card>